import { render } from "./TimeCalculatorPage.vue?vue&type=template&id=53287a86&scoped=true"
import script from "./TimeCalculatorPage.vue?vue&type=script&lang=js"
export * from "./TimeCalculatorPage.vue?vue&type=script&lang=js"

import "./TimeCalculatorPage.vue?vue&type=style&index=0&id=53287a86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53287a86"]])

export default __exports__